import script from "./PublicDocument.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicDocument.vue?vue&type=script&lang=ts&setup=true"

import "./PublicDocument.vue?vue&type=style&index=0&id=01439504&lang=css"

const __exports__ = script;

export default __exports__